
import { defineComponent } from 'vue';
import OneTimePayment from '@/components/Payments/OneTimePayment.vue';
import PaymentSettings from '@/components/Payments/PaymentSettings.vue';
import Transactions from '@/components/Transactions/TransactionsComponent.vue';
import LoanDetails from '@/components/Loans/LoanDetails.vue';
import AutopayComponent from '@/components/Payments/AutopayComponent.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';
import { AvailableLoan } from '@/interfaces/loan';
import { subscribe, unsubscribe, events } from '@/events/eventBus';
import CollectionAlerts from '@/components/Loans/Collections/CollectionAlerts.vue';
import TransactionsCollectionsAlert from '@/components/Loans/Collections/TransactionsCollectionsAlert.vue';
import ConsumerStatements from '@/components/Statements/ConsumerStatements.vue';

export default defineComponent({
  name: 'HomeView',

  components: {
    ConsumerStatements,
    TransactionsCollectionsAlert,
    CollectionAlerts,
    OneTimePayment,
    PaymentSettings,
    ResponsiveContainer,
    Transactions,
    LoanDetails,
    AutopayComponent,
  },

  data() {
    return {
      expandedPanel: null as number | null,
    };
  },

  computed: {
    loanNumber() {
      return this.$store.getters['User/activeLoanNumber'];
    },

    availableLoans() {
      return this.$store.getters['User/availableLoans'];
    },

    arePaymentsEnabled(): boolean {
      return !this.isLoanInCollections;
    },

    arePaymentSettingsEnabled(): boolean {
      if (this.isLoanInCollections) return false;

      return this.isNotPrimisLoan;
    },

    isNotPrimisLoan(): boolean {
      return this.activeLoan?.is_visible;
    },

    activeLoan(): AvailableLoan {
      return this.$store.getters['User/activeLoan'];
    },

    isLoanInCollections(): boolean {
      return this.activeLoan?.collection?.in_collection;
    },

    hasPaymentMethod(): boolean {
      return this.$store.getters['PaymentOptions/hasVerifiedPaymentMethods'];
    },
  },

  async created() {
    if (this.$store.getters['User/activeLoanNumber'] === null) {
      this.$router.push({ name: 'select-loan' });
    }

    await this.$store.dispatch('Loan/fetchLoanData', this.loanNumber);
  },

  mounted() {
    subscribe(events.PAYMENT_SETTINGS.EDIT_BANK, this.expandPaymentSettings);
    subscribe(events.PAYMENT_SETTINGS.EDIT_CARD, this.expandPaymentSettings);
    subscribe(events.AUTOPAY, this.openAutopayCard);
    subscribe(events.CLOSE_ALL_CARDS, this.closeAllCards);
  },

  destroyed() {
    unsubscribe(events.PAYMENT_SETTINGS.EDIT_BANK, this.expandPaymentSettings);
    unsubscribe(events.PAYMENT_SETTINGS.EDIT_CARD, this.expandPaymentSettings);
    unsubscribe(events.AUTOPAY, this.openAutopayCard);
    unsubscribe(events.CLOSE_ALL_CARDS, this.closeAllCards);
  },

  methods: {
    expandPaymentSettings() {
      this.expandedPanel = 1;
    },

    closeAllCards() {
      this.expandedPanel = null;
    },

    openAutopayCard() {
      this.expandedPanel = 2;
    },
  },
});
